export const enum CURRENCY {
  LABR = "labr",
  GOLD = "gold",
  BONES = "bones",
  TON = "ton",
  STAR = "star"
}

export const enum REWARD_CURRENCY {
  GOLD = "gold",
  USDT = "usdt"
}

export const enum BalanceChangeReason {
  Withdraw = "withdraw",
  Exchange = "exchange",
  MineReward = "mine-reward",
  MineEnter = "mine-enter",
  MineEarlyLeave = "mine-early-leave",
  LeaderboardReward = "leaderboard",
  Staking = "staking",
  HH = "happy-hour",
  DailyReward = "daily-reward",
  QuestReward = "quest-reward",
  LocationDiggingReward = "location-digging-reward",
  Upgrade = "upgrade",
  ExpeditionReward = "expedition-reward",
  Donate = "donate",
  InnerStore = "inner-store",
  ReferralBonus = "referral-bonus",
  Elixirs = "elixir-purchase",
  Clan = "clan",
  SkipDigging = "end-digging",
  Craft = "craft",
  EquipRune = "equip-rune",
  ResetProfession = "reset-profession",
  Auction = "auction",
  VipPass = "vip-pass",
  Compensation = "compensation",
  WeMineLabrLeaderboard = "weMine-labr-leaderboard",
  Jail = "jail",
  DEPOSIT = "deposit",
  ShopBid = "shop-bid",
  NewYearGift2026 = "new-year-gift-2026",
  RecipeSold = "recipe-sold",
  BossDrop = "boss-drop",
  Ability = "ability",
  PointsLeaderboardReward = "points-leaderboard-reward",
  SaleChestPurchase = "sale-chest-purchase",
  ClassChange = "class_change",
  CodTonMatch = "clash-of-diggers-ton-match",
  CodTonStore = "clash-of-diggers-ton-store",
  MissionChestReward = "mission-chest-reward",
  BossArenaCycleReward = "boss-arena-cycle-reward",
  TournamentEntryFee = "tournament-entry-fee",
  TournamentPrize = "tournament-prize",
  TournamentCancelRefund = "tournament-cancel-refund"
}
